<template id="aaa">
  <div class="content">
    <van-nav-bar title="消费记录详情" left-arrow @click-left="$router.go(-1)" fixed />
     <wv-group :title="data.created_at"></wv-group>
    <van-cell-group class="cell">
      <van-cell :title="data.shop_name" :value="data.code" />
    </van-cell-group>
    <div class="cell" v-for="(payment, idx) in data.payments">
      <wv-group title="服务明细">
        <section v-for="(item, index) in payment.items" :key="index" style="margin-bottom:10px">
          <wv-cell><span slot="bd" class="left normal">{{item.service_name}}<span style="margin-left:10px" class="green">{{item.hour_count}}小时</span></span><span slot="ft" class="normal">技师<span>{{item.masseur_code}}</span></span></wv-cell>
          <wv-flex>
            <wv-flex-item>
              <wv-cell><span slot="bd" class="left">单价</span><span slot="ft">{{item.rate}}</span></wv-cell>
            </wv-flex-item>
            <wv-flex-item>
              <wv-cell><span slot="bd" class="left">总价</span><span slot="ft">{{item.total}}</span></wv-cell>
            </wv-flex-item>
          </wv-flex>
        </section>
      </wv-group>
      <wv-cell><span slot="bd" class="left" style="border:none">原价合计</span><span class="green" slot="ft">{{payment.origin_amount}}</span></wv-cell>
      <wv-group title="支付明细">
        <section v-for="(item, index) in payment.payment_items" :key="index + 1" style="margin-bottom:10px">
          <wv-flex>
            <wv-flex-item>
              <wv-cell><span slot="bd" class="left">支付</span><span  slot="ft"><span style="margin-right:10px">({{item.get_method_display}})</span>{{item.amount}}</span></wv-cell>
            </wv-flex-item>
          </wv-flex>
          <wv-flex>
            <wv-flex-item>
              <wv-cell v-show="item.card_number !== null">
                <span slot="bd" class="left">卡号</span><span slot="ft">{{item.card_number}}</span></wv-cell>
            </wv-flex-item>
          </wv-flex>
          <wv-flex>
            <wv-flex-item>
              <wv-cell v-show="item.amount_after_payment !== null">
                <span slot="bd" class="left">主卡支付</span><span slot="ft">
                  {{item.amount_before_payment}} -> {{item.amount_after_payment}}
                </span>
              </wv-cell>
            </wv-flex-item>
          </wv-flex>
          <wv-flex>
            <wv-flex-item v-for="(bonus_item, index) in item.bonus_payment_items" :key="index + 1">
              <wv-cell>
                <span slot="bd" class="left">赠卡{{bonus_item.bonus_item_sequence}}支付</span>
                <span slot="ft">{{bonus_item.amount_before_payment}} -> {{bonus_item.amount_after_payment}}</span>
              </wv-cell>
            </wv-flex-item>
          </wv-flex>
        </section>
      </wv-group>
      <wv-cell><span slot="bd" class="left">合计实付</span><span class="red" slot="ft">{{payment.actual_amount}}</span></wv-cell>
    </div>
  </div>
</template>
<script>
import { getExpenseCalendar } from '@/api/login'

export default {
  created() {
    this.fechData()
  },
  name: 'expenseCalendar',
  data() {
    return {
      data: {}
    }
  },
  methods: {
    fechData() {
      getExpenseCalendar(this.$route.query.code).then(res => {
        this.data = res
      })
    },

  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.weui-cell {
  font-size: 14px;
  color: #D98719;
  border: none;
  background-color: #fff;
}

.fl .weui-cell {
  float: left;
  width: 39%;
}

.left {
  float: left;
}

.cell .van-cell {
  padding: 10px 20px;
}

.van-divider {
  margin: -4px 0 4px 0;
}

.cell .van-cell__title {
  text-align: left;
  color: #D98719;

}

.cell .van-cell__value {
  color: rgb(102, 102, 102);
}

.normal {
  color: #2c3e50
}

.green {
  color: #09bb07
}

.red {
  color: #F56C6C
}

</style>



// WEBPACK FOOTER //
// src/components/cards/expenseCalendar.vue